import React, { PropTypes } from 'react';
import LightBox from '../Common/LightBox';
import Dropzone from 'react-dropzone';
import { disableOpenFileInBrowser } from '../../businessLogic/util';
import SparkMD5 from 'spark-md5';
import { prettyAlert } from '../Common/Dialog';

export default class ImportarFotosBase extends React.Component {

	constructor(props) {
		super(props);
		this.state = { 
			is_lightbox_open: false, 
			className: 'dropzone imagens-georeferenciadas', 
			disabled: false, 
			errorMessage: false, 
			fileLoading: 'none', 
			filesQTDE: '0', 
			fileNum: '0',
			fotos: [],
			isProcessing: false,
			processingFilename: ""
		};
		disableOpenFileInBrowser();
	}

	getStyle() {
		return {
			overlay: { backgroundColor: 'rgba(255, 255, 255, 0.75)' },
			content: { 
				height: `400px`,
				width: `400px`,
				overflowY: "auto", 
				overflowX: "hidden"
			}
		};
	}

	async onDrop(files) {}

	async readFileAsync(file) {
		return new Promise((resolve, reject) => {
			let a = new FileReader();
			
			let filehash = 0;
			a.readAsArrayBuffer(file);
			let fileReturns = {};
			a.onload = () => {
				filehash = SparkMD5.ArrayBuffer.hash(a.result);

				fileReturns = this.props.checkExistance(filehash);
				fileReturns.then( function(e) {
					e.filehash = filehash;
					if (e.tem_em_documento_no_bd) {
						file.DocumentID = e.documents_in_bd[0];
					}
				});
				resolve(fileReturns);
			};
		});
	}

	async checkExistance(fileblob) {
		
		let a = new FileReader();
		
		let filehash = 0;
		let fileReturns = {};
		a.readAsArrayBuffer(fileblob);

		a.onload = function () {
			filehash = SparkMD5.ArrayBuffer.hash(a.result);

		};
		a.onloadend = () => {
			fileReturns = this.props.checkExistance(filehash);
		};
		return fileReturns[0];
	}

	showAlert(repeatedPicturesInDatabase) {
		prettyAlert(
			"Arquivos já cadastrados", (
			<div>
				{repeatedPicturesInDatabase.map((filename, key) => (
					<p key={key}> {filename} </p> 
				))}
				<br />
				<i>Esses arquivos <b>não</b> foram adicionados porquê já existem na base.</i>
			</div>
			)
		);
	}

	getContent() {
		if (this.state.isProcessing) {
			return (
				<div className='imagens-georeferenciadas processing'>
					<div className='titulo'>
						<span>Processando imagens...</span>
					</div>
					<div className='centerSpin'>
						<i className='fas fa-circle-notch fa-spin' />
					</div>
					<div className='filename'>
						<span>{this.state.processingFilename}</span>
					</div>
				</div>
			);
		}

		return (
			<div 
				onMouseOver={() => this.setState({className: 'dropzone imagens-georeferenciadas dropzone-active'})}
				onMouseOut={() => this.setState({className: 'dropzone imagens-georeferenciadas'})}>
				<Dropzone 						
					onDrop={this.onDrop.bind(this)}
					className={this.state.className}
					activeClassName='dropzone imagens-georeferenciadas dropzone-active' 
					multiple
				>
					<div className="dropzone-text">
						"Arraste e solte imagens aqui, ou clique para fazer o upload"
					</div>
				</Dropzone>						
			</div>
		);
	}

	render () {				
		return (	
			<LightBox						
				isOpen={this.state.is_lightbox_open}						 
				onClose={() => this.setState({is_lightbox_open: false})}
				>
				{this.getContent()}
			</LightBox>					
		);
	}
}

ImportarFotosBase.propTypes = {
	checkExistance: PropTypes.func.isRequired
	// isProcessing: PropTypes.bool.isRequired,
	// setProcessingFilename: PropTypes.func.isRequired,
	// processingFilename: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Documents/ImportarFotosBase.js